@if (emptyList()) {
  <ng-container *ngTemplateOutlet="empty" />
} @else {
  <app-table
    [columns]="tableColumnsService.visibleColumns()"
    [datas]="tableData()"
    [actions]="actions()"
    (columnsChange)="tableColumnsService.reorderColumns($event)"
    [skeletonCount]="skeletonCount()"
  />

  <app-paginator
    [isLoading]="!tableData()"
    [page]="playlistTableContentService.currentPage()"
    [totalItems]="playlistTableContentService.totalItems()"
    [itemsPerPage]="playlistTableContentService.contentLimitPerPage()"
    (nextPage)="playlistTableContentService.nextPage()"
    (previousPage)="playlistTableContentService.previousPage()"
    [firstItemInCurrentPage]="playlistTableContentService.firstItemInPage()"
    [lastItemInCurrentPage]="playlistTableContentService.lastItemInPage()"
    [lastPage]="playlistTableContentService.lastPage()"
    (goToPage)="playlistTableContentService.goToPage($event)"
    (setItemPerPage)="playlistTableContentService.setItemPerPage($event)"
  />
}

<ng-template #empty>
  <app-empty-content-list-element contentType="workout" />
</ng-template>
